import { graphql } from '~/gql';

/**
 * Picker/list query for attorneys: distinct experts from their matters.
 * Inline expert fields (no separate fragment) so client-preset `graphql()` maps to a full operation document.
 */
export const MyMatterExpertsDocument = graphql(`
  query MyMatterExperts {
    myMatterExperts {
      id
      name
      email
      avatarUrl
    }
  }
`);
